export enum SendCodeType {
    NONE = 0, 
    SMS = 1, 
    IVR = 2
}


// WEBPACK FOOTER //
// ./src/app/enums/send-code-type.enum.ts